import { createSelector } from '@ngrx/store';
import {
  getTransferConnectState,
  TransferConnectV2State,
} from '../reducers/index';
import { MembershipState } from '../reducers/membership.reducer';

const getMembershipState = createSelector(
  getTransferConnectState,
  (state: TransferConnectV2State) => state.membership,
);

const getCreateMembership = (state: MembershipState) => state.createMembership;
const getUpdateMembership = (state: MembershipState) => state.updateMembership;

export const getMembershipMemberships = createSelector(
  getMembershipState,
  (membershipState) => membershipState.memberships.data,
);

export const getMembershipsIsLoaded = createSelector(
  getMembershipState,
  (membershipState) => membershipState.memberships.isLoaded,
);

export const getMembershipError = createSelector(
  getMembershipState,
  (membershipState) => membershipState.memberships.error,
);

export const getMembershipLoading = createSelector(
  getMembershipState,
  (membershipState) => membershipState.memberships.loading,
);

export const getCreateMembershipSelector = createSelector(
  getMembershipState,
  getCreateMembership,
);

export const getUpdateMembershipSelector = createSelector(
  getMembershipState,
  getUpdateMembership,
);

export const getCreateMembershipIsLoading = createSelector(
  getCreateMembershipSelector,
  (state: MembershipState['createMembership']) => state.loading,
);

export const getUpdateMembershipIsLoading = createSelector(
  getUpdateMembershipSelector,
  (state: MembershipState['updateMembership']) => state.loading,
);

export const getCreateOrUpdateMembershipIsLoading = createSelector(
  getCreateMembershipIsLoading,
  getUpdateMembershipIsLoading,
  (createIsLoading, updateIsLoading) => {
    return createIsLoading || updateIsLoading;
  },
);

export const getMembershipsOrUpdateMembershipIsLoading = createSelector(
  getMembershipLoading,
  getUpdateMembershipIsLoading,
  (membershipsLoading, updateIsLoading) => {
    return membershipsLoading || updateIsLoading;
  },
);
